const types = {
  NEWSLETTER: "NEWSLETTER",
  NEWSLETTER_RESPONSE: "NEWSLETTER_RESPONSE",

  ABOUT_US: "ABOUT_US",
  ABOUT_US_RESPONSE: "ABOUT_US_RESPONSE",
  ABOUT_US_RESPONSE_CLEAR: "ABOUT_US_RESPONSE_CLEAR",

  CONTACT_US: "CONTACT_US",
  CONTACT_US_RESPONSE: "CONTACT_US_RESPONSE",
  CONTACT_US_RESPONSE_CLEAR: "CONTACT_US_RESPONSE_CLEAR",

  HELP_US:"HELP_US",
  HELP_US_RESPONSE:"HELP_US_RESPONSE",
  HELP_US_RESPONSE_CLEAR:'HELP_US_RESPONSE_CLEAR'
};

export default types;
